import secureLocalStorage from "react-secure-storage";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import React from "react";
import "../../Styles/RiskDiscription.scss";
import { filterBy } from "@progress/kendo-data-query";
export default class RiskCustomFieldDropdownCell extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      dropdownListData: [],
      dropdownListDataTemp:[],
      value: [],
      viewValue: [],
    };
  }
  componentDidMount() {
    if (this.props.customFieldsData) {
      this.initLoadData();
    }
  }

  initLoadData = () => {
    try {
      let customFields = this.props.customFieldsData;

      let field = this.props.field;
      let options = customFields.find((item) => item.fieldName == field);
      if (options && options.cfPossibleValues) {
        let array1=options.cfPossibleValues.filter(
          (item) => item.possibleValues != " [blank]"
        );
        const cf = this.props.dataItem?.customFields.find(
          (item) => item.fieldName == this.props.field
        );
        let array2=cf?.cfPossibleValues||[];
        const commonObjects = array1.filter(obj1 => 
          array2.some(obj2 => obj1.id === obj2.id)
        );
        this.setState(
          {
            ...this.state,
            dropdownListData: commonObjects ,
            dropdownListDataTemp:commonObjects
          },
          () => this.retriveSelectedData()
        );
      }
    } catch (err) {}
  };

  retriveSelectedData = () => {
    let selectedValue = this.props.dataItem[this.props.field]
      ? this.props.dataItem[this.props.field]
      : "";
    let arr = selectedValue?.toString()?.trim()?.split(",");
    let res = [];
    let viewValue = [];
    arr.map((item) => {
      let val = this.state.dropdownListData.find((dd) => dd.hashValue == item);
      if (val) {
        res.push(val);
        viewValue.push(val.possibleValues);
      }
    });

    this.setState({
      ...this.state,
      value: res,
      viewValue: viewValue?.toString(),
    });
  };
  handleChange = (event) => {
    this.setState({
      value: event.target.value,
      viewValue: [],
    });
  };
  handleChangeBlur = (e) => {
    try {
      if (this.props.dataItem && !this.props.dataItem.riskRegisterId) {
        //create
        console.log("create");
        // this.saveRiskCustomFieldValue(e);
      } else {
        //update
        console.log("update");
        this.updateRiskCustomFieldValue(e);
      }
    } catch (err) {}
  };

  saveRiskCustomFieldValue = (e) => {
    try {
      let customFields = this.props.customFieldsData;
      let field = this.props.field;
      let options = customFields.filter((item) => item.fieldName == field);

      if (options && options.length > 0 && options[0].cfPossibleValues) {
        this.props.manageCustomValuesSave([
          {
            CustomFieldValue: options[0].id,
            RiskId: 0,
            PossibleFieldId: this.state.value,
          },
        ]);
      }
    } catch (err) {}
  };

  updateRiskCustomFieldValue = (e) => {
    try {
      let customFields = this.props.customFieldsData;
      let field = this.props.field;
      let options = customFields.filter((item) => item.fieldName == field);

      if (options && options.length > 0 && options[0].cfPossibleValues) {
        let val = {
          ...this.props.dataItem,
          riskCustomField: {
            CustomFieldValue: options[0].id,
            RiskId: this.props.dataItem.riskRegisterId,
            PossibleFieldId: this.state.value, //e.value.id,
          },
        };
        this.props.manageCustomValues(val);
      }
    } catch (err) {}
  };
  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
      this.props.onEditCell(
        this.props.dataItem,
        this.props.field,
        this.props.stateData
      );
    }
  };
  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
          autoComplete="off"
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  handlefilter = (e) => {
    const filteredvalue = filterBy(this.state.dropdownListDataTemp, e.filter);

    this.setState({
      dropdownListData: filteredvalue,
    });
  };
  getSortedList = () => {

    let sortedlist = this.state.dropdownListData.sort(function (a, b) {
      if (a.possibleValues < b.possibleValues) {
        return -1;
      }
      if (a.possibleValues > b.possibleValues) {
        return 1;
      }
      return 0;
    });
    return sortedlist;
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;

    const value = this.state.value;
    const selected = value.length;
    let selectedValue = this.props.dataItem[this.props.field]
      ? this.props.dataItem[this.props.field]
      : "";
    let arr = selectedValue?.toString()?.trim()?.split(",");

    let viewValue = [];
    arr.map((item) => {
      if (item === "") {
        return;
      }
      
      let val = this.state.dropdownListDataTemp.find((dd) => dd.hashValue == item);
      if (val) {
        // Don't display [blank] values
        if (val.possibleValues.trim() !== "[blank]") {
          viewValue.push(val.possibleValues);
        }
      } else {
        // If we can't find the value in dropdownListDataTemp, try to find it in the customFieldsData
        const customFields = this.props.customFieldsData;
        const fieldOptions = customFields.find((cf) => cf.fieldName === field);
        if (fieldOptions && fieldOptions.cfPossibleValues) {
          const possibleValue = fieldOptions.cfPossibleValues.find(
            (pv) => pv.hashValue === item
          );
          if (possibleValue) {
            // Don't display [blank] values
            if (possibleValue.possibleValues.trim() !== "[blank]") {
              viewValue.push(possibleValue.possibleValues);
            }
          }
        }
      }
    });
    viewValue=viewValue.length===0?dataItem[field]:viewValue;
    const cf =
      this.props.dataItem.customFields &&
      this.props.dataItem.customFields.find(
        (item) => item.fieldName == this.props.field
      );
    let access = false;
    if (cf) {
      access = true;
    }

    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit
      // || this.props.dataItem.inEdit === true
    ) {
      return (
        <td>
          <MultiSelect
            style={{ width: "100px !important" }}
            onChange={this.handleChange}
            onBlur={this.handleChangeBlur}
            itemRender={this.itemRender}
            value={value}
            id="customeFieldId"
            data={this.getSortedList()}
            valueField="id"
            textField="possibleValues"
            autoClose={false}
            tags={
              selected > 0
                ? [{ text: `${selected} items selected`, data: [...value] }]
                : []
            }
            filterable={true}
            onFilterChange={(e) => this.handlefilter(e)}
          />
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId && access) {
        return (
          <td onClick={this.handleEditCell} title={viewValue}>
            {" "}
            {viewValue?.toString()}
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ||
          !access ? (
          <td title={viewValue?.toString()}> {viewValue?.toString()}</td>
        ) : (
          <td onClick={this.handleEditCell} title={viewValue}>
            {" "}
            {viewValue?.toString()}
          </td>
        );
      }
    }
  }
}
